import { CHANGE_SERVICE_PROJECT, CHANGE_TAB } from '../constant/ActionType';

let initialState = {
  pssr: {
    service_id: null,
    service_name: null,
    project_id: [],
    project_name: null
  },
  activeTab: ""
};

function pssrReducer(state = initialState, action) {

  switch (action.type) {
    case CHANGE_SERVICE_PROJECT:
      return {
        ...state,
        pssr: {
          ...action.payload
        }
      }
    case CHANGE_TAB:
      return {
        ...state,
        activeTab: action.payload
      }
      break;
    default:
      return state;
      break;
  }
};

export default pssrReducer;
